export default function overflowTitle (Vue) {
  Vue.directive('overflow-title', {
    bind (el, binding) {
      el.dataset.titleText = binding.value;

      el.mouseHandler = () => {
        if (el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight) {
          el.title = el.dataset.titleText;
        } else {
          el.removeAttribute('title');
        }
      };

      el.addEventListener('mouseover', el.mouseHandler);
    },
    update (el, binding) {
      el.dataset.titleText = binding.value;
    },
    unbind (el) {
      el.removeEventListener('mouseover', el.mouseHandler);
    }
  });
}
